import Sentry from "api/sentry";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
  ensureInitialized,
} from "firebase/remote-config";
import app from "./app";

const remoteConfig = getRemoteConfig(app);

// in production, fetch new values every 4 hours
remoteConfig.settings.minimumFetchIntervalMillis = process.env.REACT_APP_NODE_ENV === "development" ? 0 : 14400000;

// Use these config properties as keys to extract them from remote config
const REMOTE_CONFIG_KEYS = {
  FLAG_B: "feature_flag_B",
};

// default remote-config values for the FE in case we can't connect to firebase
// This should contain the list of remote config values our app is currently using
const REMOTE_CONFIG_DEFAULT_KEY_VALUES = {
  [REMOTE_CONFIG_KEYS.FLAG_B]: "default feature_flag_B value",
};
remoteConfig.defaultConfig = REMOTE_CONFIG_DEFAULT_KEY_VALUES;

/* Helper Functions */
const validKey = (keyToMatch) => {
  const currentKeyList = Object.values(REMOTE_CONFIG_KEYS);
  const keyExists = currentKeyList.find((existingKey) => existingKey === keyToMatch);
  return !!keyExists;
};

/* Remote config API */
const initRemoteConfig = async () => {
  let remoteValues;
  try {
    remoteValues = await fetchAndActivate(remoteConfig);
  } catch (err) {
    err.knownError = "Failed to fetch remote config values";
    Sentry.captureException(err);
    return;
  }
  if (!remoteValues){
    console.log("Already activated. Fetching remote config values from firebase cache");
  }
};

const getRemoteConfigValue = async (key) => {
  if(!validKey(key)) { throw new Error(`Attempting to fetch key ${key} for remote config`); }

  // make sure initialization of firebase is good to go before attempting to fetch values
  await ensureInitialized(remoteConfig);

  // extract raw value for now. We can add in value types later i.e. asNumber() etc.
  return getValue(remoteConfig, key)._value;
};

export {
  initRemoteConfig,
  getRemoteConfigValue,
  REMOTE_CONFIG_KEYS,
  REMOTE_CONFIG_DEFAULT_KEY_VALUES,
};
